import axios, { AxiosError } from 'axios'
import { config } from '../config/env'
import { cookies } from '../utils/cookies'

export const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    Authorization: !!cookies && cookies ? `Bearer ${cookies.get('@AXAuth:Token')}` : '',
  },
})

api.interceptors.response.use(
  (response) => {
    return response
  },
  async (err: AxiosError) => {
    const status = err.response?.status
    const statusText = err.response?.statusText
    const ignore401 = (err.config as any)?.headers?.['X-Ignore-401']

    if (!ignore401 && (status === 401 || statusText === 'Unauthorized')) {
      cookies.remove('@AXAuth:Token', { path: '/' })
      cookies.remove('@AXAuth:User', { path: '/' })
      cookies.remove('@AXAuth:Permissions', { path: '/' })
      delete api.defaults.headers['Authorization']
      if (window.location.pathname !== '/') {
        window.location.replace('/')
      }
    }

    return Promise.reject(err)
  },
)
